/* eslint-disable perfectionist/sort-imports */
import 'src/global.css';

// ----------------------------------------------------------------------

import Router from 'src/routes/sections';

import ThemeProvider from 'src/theme';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import ProgressBar from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context/supabase';
import SnackbarProvider from 'src/components/snackbar/snackbar-provider';
import { LocalizationProvider } from 'src/locales';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import OverlayManager from './overlay';
import { ScreenWidthGuard } from './auth/guard';
// ----------------------------------------------------------------------

const router = createBrowserRouter([{ path: '*', Component: Root }]);
export default function App() {
  return <RouterProvider router={router} />;
}

function Root() {
  useScrollToTop();

  return (
    <AuthProvider>
      <OverlayManager />
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light',
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'vertical', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <ScreenWidthGuard>
              <MotionLazy>
                <SnackbarProvider>
                  <SettingsDrawer />
                  <ProgressBar />
                  <Router />
                </SnackbarProvider>
              </MotionLazy>
            </ScreenWidthGuard>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
    </AuthProvider>
  );
}
